import { useRef as f, useCallback as c } from "react";
var n = function(e, r) {
  if (typeof e == "function") {
    e(r);
    return;
  }
  e.current = r;
}, a = function(e, r) {
  var t = f();
  return c(function(u) {
    e.current = u, t.current && n(t.current, null), t.current = r, r && n(r, u);
  }, [r]);
};
export {
  a as default
};
